import { render, staticRenderFns } from "./InactiveUser.vue?vue&type=template&id=57557c6c&scoped=true"
import script from "./InactiveUser.vue?vue&type=script&lang=js"
export * from "./InactiveUser.vue?vue&type=script&lang=js"
import style0 from "./InactiveUser.vue?vue&type=style&index=0&id=57557c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57557c6c",
  null
  
)

export default component.exports